import React from 'react';
import { useRouter } from '../../../../../../@casino/useRouter';
import classes from './style.module.css';

const ProviderItem = ({
    id,
    is_disabled,
    name
}) => {
    const router = useRouter();
    const handleClick = () => {
        router.history.push(`/providers/edit/${id}`)
    }

    return (
        <div
            onDoubleClick={handleClick}
            className={classes.game}
        >
            <div className={classes.wrap__provider}>
                <span className={classes.provider__text}>{name}</span>
                <span className={is_disabled ? classes.status__error : classes.status__success}>
                    {is_disabled ? 'Отключен' : 'Включен'}
                </span>
            </div>
        </div>
    )
}

export default ProviderItem;